export default "__VITE_ASSET__C4eovfSr__"